<template>
  <div color="white">
    <v-row align="center">
      <v-col cols="4">
        <v-row>
          <span class="card-text-large">{{shipment.departure | justTime($i18n.locale)}} - {{shipment.arrival | justTime($i18n.locale)}}</span>
          <span class="font-weight-light">{{shipment.departure | dateToReadableFull($i18n.locale)}}</span>
        </v-row>
      </v-col>

      <v-col cols="4">
        <v-row>
          <span class="card-text-large">{{shipment.company}}</span>
          <span class="font-weight-light">{{shipment.price}}€ &#9679; {{shipment.quotes}} Quotes</span>
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row />
      </v-col>

      <v-col cols="2">
        <v-row>
          <v-row justify="end">
            <v-chip color="#EF476F">{{shipment.label}}</v-chip>
            <v-chip color="#6A68CD">{{shipment.status}}</v-chip>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'CardExpress',
  props: {
    shipment: Object
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.card-text-large {
  font-size: 17px;
}
</style>
